/** SPA route for denied/missing storage file opens (not app-role /access-denied). */
export const FILE_ACCESS_RESTRICTED_ROUTE = '/files/access-restricted';

/**
 * Builds the restricted-file page href.
 * Optional `reason` is for telemetry/debugging only — page copy stays generic.
 */
export function fileAccessRestrictedHref(reason?: string): string {
  const trimmed = (reason ?? '').trim();
  if (!trimmed) return FILE_ACCESS_RESTRICTED_ROUTE;
  const params = new URLSearchParams();
  params.set('reason', trimmed);
  return `${FILE_ACCESS_RESTRICTED_ROUTE}?${params.toString()}`;
}

/** True when an HTTP status should surface as the shared restricted page (403/404). */
export function isFileAccessRestrictedStatus(status: number): boolean {
  return status === 403 || status === 404;
}
